import React from 'react'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ReferralStep from './ReferralStep'

const ReferralProgramSteps = () => {
  const { isMobile } = useBreakpoint()

  return (
    <Box
      paddingTop="s48"
      paddingBottom="s48"
      justifyContent="center"
      style={{
        maxWidth: '1248px',
      }}
    >
      <Box
        flexDirection={isMobile ? 'column' : 'row'}
        gap={isMobile ? 's32' : 's24'}
        paddingLeft={isMobile ? 's24' : 's24'}
        paddingRight={isMobile ? 's24' : 's24'}
      >
        <ReferralStep
          number={1}
          title={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.copy_link.title'
          )}
          description={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.copy_link.subtitle'
          )}
        />
        <ReferralStep
          number={2}
          title={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.share_link.title'
          )}
          description={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.share_link.subtitle'
          )}
        />
        <ReferralStep
          number={3}
          title={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.handle_rest.title'
          )}
          description={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.handle_rest.subtitle'
          )}
        />
      </Box>
    </Box>
  )
}

export default ReferralProgramSteps
